import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { Checkbox } from 'components';
import { ErrorMessage } from 'formik';

const CheckboxField = props => {
  const { formikProps, field, renderRequiredIcon, renderEmptyElement } = props;
  const { isSubmitting } = formikProps;
  const {
    name,
    required,
    labels,
    caption,
    subCaption = '',
    view = '',
    align = 'center',
  } = field;

  return (
    <div
      key={name}
      className="form__field checkbox d-flex flex-column align-items-center"
    >
      {caption !== '' ? (
        <label htmlFor="name" className="field-label text-center">
          {ReactHtmlParser(caption)}
          {required && renderRequiredIcon()}
          <span>{subCaption}</span>
        </label>
      ) : null}
      <div
        className={`check-fields-wrapper d-flex flex-wrap justify-content-${align} ${
          view === 'block' ? '' : 'col-md-12 col-sm-12 p-0'
        }`}
      >
        {labels.map(item => (
          <Checkbox
            key={item}
            name={name}
            value={item}
            view={view}
            disabled={isSubmitting}
          />
        ))}
        {align === 'start' && renderEmptyElement()}
      </div>
      <ErrorMessage
        render={msg => <div className="validateError">{msg}</div>}
        name={name}
      />
    </div>
  );
};

CheckboxField.propTypes = {
  formikProps: PropTypes.object.isRequired,
  field: PropTypes.object.isRequired,
  renderRequiredIcon: PropTypes.func.isRequired,
  renderEmptyElement: PropTypes.func.isRequired,
};

export default CheckboxField;
